export default __webpack_public_path__ + "static/media/ribbon4.de4bad33.svg";